// Canonical UTM query-param keys, shared so apps don't each redefine (and drift)
// the set.
export const UTM_PARAM_KEYS = [
  "utm_campaign",
  "utm_source",
  "utm_medium",
  "utm_term",
  "utm_content",
] as const

export type UtmParamKey = (typeof UTM_PARAM_KEYS)[number]
